import { defineStore } from "pinia";

import type { IEmployee } from "../interfaces/IEmployee";
import type { JsonResponse } from "../interfaces/JsonResponse";
import EmployeesService, { type IEmployeeResponse } from "../services/EmployeesService";

interface IState {
    employee: IEmployee | null;
    employeeLoading: boolean;
    bgColor: string | null;
}

export const appStore = defineStore("appStore", {
    state: (): IState => ({
        employee: null,
        employeeLoading: false,
        bgColor: null,
    }),
    actions: {
        async signInOnDevice(key: string, employee: IEmployee): Promise<IEmployeeResponse | JsonResponse> {
            this.employeeLoading = true;
            try {
                const tabletId = localStorage.getItem(`${key}TabletId`) || "";
                const response = await EmployeesService.signInOnDevice(employee.id, parseInt(tabletId, 10));
                if (response.result === "success") {
                    this.employee = response.employee;
                    localStorage.setItem(`${key}EmployeeId`, this.employee.id.toString());
                } else {
                    this.signOut();
                }
                this.employeeLoading = false;
                return response;
            } catch (error) {
                // Return a JsonError object on error
                return {
                    result: "error",
                    msg: error instanceof Error ? error.message : "Unknown error",
                };
            }
        },
        // Locally sign out.
        signOut(): void {
            localStorage.removeItem("employeeId");
            this.employee = null;
        },
        // Sing out from device with server request.
        async signOutFromDevice(key: string, employee: IEmployee): Promise<JsonResponse> {
            try {
                const tabletId = localStorage.getItem(`${key}TabletId`) || "";
                localStorage.removeItem(`${key}EmployeeId`);
                const response = await EmployeesService.signOutFromDevice(employee.id, parseInt(tabletId, 10));
                if (response.result === "success") {
                    this.signOut();
                }
                return response;
            } catch (error) {
                // Return a JsonError object on error
                return {
                    result: "error",
                    msg: error instanceof Error ? error.message : "Unknown error",
                };
            }
        },
        async autoSignInOnDevice(key: string): Promise<void> {
            this.employeeLoading = true;
            const employeeId = localStorage.getItem(`${key}EmployeeId`) || "";
            const tabletId = localStorage.getItem(`${key}TabletId`) || "";
            if (employeeId !== "" && tabletId !== "") {
                const response = await EmployeesService.signInOnDevice(
                    parseInt(employeeId, 10),
                    parseInt(tabletId, 10),
                );
                if (response?.result === "success") {
                    this.employee = response.employee;
                    localStorage.setItem(`${key}EmployeeId`, this.employee.id.toString());
                } else {
                    // alert(response.msg);
                    this.signOut();
                }
            } else {
                // this.goToSignIn();
            }
            this.employeeLoading = false;
        },
    },
    getters: {
        getEmployee: (state) => state.employee,
        isEmployeeLoading: (state) => state.employeeLoading,
    },
});
